import { useEffect, useState } from "react";

export const useFetch = (url: string, options: {}, type: 'text' | 'json' = 'json') => {
    const [response, setResponse] = useState<any>(null);
    const [error, setError] = useState<Error | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!url) return;

        const fetchData = async () => {
            setIsLoading(true);
            setResponse(null);

            try {
              const res = await fetch(url, options);

              if(type === 'json') {
                const json = await res.json();
                setResponse(json);
              } else {
                const text = await res.text();
                setResponse(text);
              }
            } catch (error) {
              setError(error instanceof Error ? error : new Error(String(error)));
            } finally {
              setIsLoading(false);
            }
        };

        fetchData();
    }, [url]);

    return { response, error, isLoading };
};
